/**
 * Cross-component signal when SaaS entitlements change (e.g. after checkout).
 * Header credit pill and billing hub listen and re-fetch without a full reload.
 */

export const SAAS_ENTITLEMENTS_UPDATED_EVENT = "tv:saas-entitlements-updated";

/**
 * @param {string|number} accountId
 */
export function notifySaasEntitlementsUpdated(accountId) {
  if (typeof window === "undefined" || accountId == null || accountId === "") {
    return;
  }
  window.dispatchEvent(
    new CustomEvent(SAAS_ENTITLEMENTS_UPDATED_EVENT, {
      detail: {
        accountId: String(accountId),
      },
    })
  );
}
